
<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm8")
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Información del Empleado
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(
                      dense,
                      outlined,
                      v-model='form.nombre',
                      :readonly='read',
                      id='nombreEmpleado',
                      label='Nombre',
                      v-uppercase)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(
                      dense,
                      outlined,
                      v-model='form.apellido',
                      :readonly='read',
                      id='apellidoEmpleado',
                      label='Apellido',
                      v-uppercase)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined v-model='form.cedula' :readonly='read' id='cedulaEmpleado' v-mask="'########'" label='Cedula')
                  v-col(cols='12' sm='12' md='4' class='d-flex justify-center')
                    div
                      div(class="d-flex justify-space-around")
                        div( class="pa-0 mr-2" style="width:70px")
                          v-select(v-model='rifLetra' :readonly='read' :items='items2' outlined dense )
                        div( class="pa-0")
                          v-text-field(outlined dense v-model='rifNumerico' :readonly='read' id='rifEmpleado' label='Rif' v-mask="'#########'")
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined v-model='form.telefono' :readonly='read' id='telefonoEmpleado' v-mask="'(####)###-##-##'" label='Telefono')
                  v-col(cols='12')
                    v-textarea(dense outlined auto-grow v-model='form.direccion' :readonly='read' id='direccionEmpleado' label='Direccion')
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Tipo
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='4')
                    v-autocomplete(
                      id='tipoEmpleado',
                      autocomplete="off",
                      @change="tipoSeleccionado",
                      :menu-props="{closeOnContentClick: true}",
                      v-model='selecEmp',
                      :readonly='read',
                      label='Tipo de empleado',
                      :items='tipoArray'
                      outlined,
                      dense)
                      template(v-slot:prepend-item v-if="true")
                        v-list(dense)
                          v-list-item(@click='tipoEmp = true')
                            v-list-item-avatar(color='grey_1')
                              v-btn.mx-2(fab, dark, x-small, color='success')
                                v-icon(dark, small) mdi-plus
                            v-list-item-content
                              v-list-item-title
                                | Agregar Tipo Empleado
                    tipo-empleado-m(
                      :dialog='tipoEmp',
                      :editedIndex='-1',
                      @close='tipoEmp = false',
                      @save='getTipoEmpleado')

                v-row(v-if="editedIndex === -1")
                  v-col(cols='12' sm='12' md='4' v-if='mostrarPoRu && config.portafolio.valor')
                    v-select(v-model='form.codPortafolio' multiple :readonly='read' :items='idPortafolioArray' id='portafolioEmpleado' label='Portafolio' dense outlined)
                  v-col(cols='12' sm='12' md='4' v-if='mostrarPoRu && config.zona.valor')
                    v-select(v-model='selecZ' :readonly='read' :items='idZonaArray' id='zonaEmpleado' label='Zona' dense outlined @change="zonaSeleccionada")
                  v-col(cols='12' sm='12' md='4')
                    v-select(v-if='mostrarPoRu && config.ruta.valor' v-model='selecR' :readonly='read' :items='idRutaArray' id='rutaEmpleado' label='Ruta' dense outlined @change="rutaSeleccionada")
                v-row(v-else)
                  v-col(cols='12' sm='12' md='4' v-if='mostrarPoRu && config.portafolio.valor')
                    v-select(v-model='form.codPortafolio' multiple :readonly='read' :items='idPortafolioArray' id='portafolioEmpleado' label='Portafolio' dense outlined)
                  v-col(cols='12' sm='12' md='4' v-if='mostrarPoRu && config.zona.valor')
                    v-select(v-if='form.codZona' v-model='form.codZona._id' :readonly='read' :items='idZonaArray' id='zonaEmpleado' label='Zona' dense outlined)
                  v-col(cols='12' sm='12' md='4')
                    v-select(v-if='form.codRuta' v-model='form.codRuta._id' :readonly='read' :items='idRutaArray' id='rutaEmpleado' label='Ruta' dense outlined)
                //-Hijo ListadoVendedores
                v-row(dense)
                  v-col(v-if='mostrar' align='center' cols='12' sm='12' md='12')
                    ListadoVendedores(p='activar' :prod='form.vendedor' :read='read')
                  v-col(v-else-if='mostrarClientes' align='center' cols='12' sm='12' md='12')
                    listado-clientes(p='activar', :prod='form.clientes' :read='read')
                  v-col(v-else-if='mostrarPromotores' align='center' cols='12' sm='12' md='12')
                    listado-promotores(p='activar', :prod='form.promotores' :read='read')
                //v-row(dense)
                  v-col(cols='12' sm='12' md='6')
                    v-dialog(ref='dialog1' v-model='modalIngreso' :return-value.sync='dateIngreso' persistent width='300px')
                      template(v-slot:activator='{ on }')
                        v-text-field(v-model='form.fechaIngreso' label='Fecha de Ingreso' prepend-icon='event' :readonly='read' dense outlined v-on='on')
                      v-date-picker(v-model='form.fechaIngreso' :readonly='read' locale="es")
                        v-spacer
                        v-btn(small dark color='red' @click='modalIngreso = false') Cancelar
                        v-btn(small dark color='success' @click='$refs.dialog1.save(dateIngreso)') Ok
                  v-col(cols='12' sm='12' md='6')
                    v-dialog(ref='dialog2' v-model='modalVacaciones' :return-value.sync='dateVacaciones' persistent width='300px')
                      template(v-slot:activator='{ on }')
                        v-text-field(v-model='form.fechaVacaciones' label='Fecha de Vacaciones' prepend-icon='event' :readonly='read' dense outlined v-on='on')
                      v-date-picker(v-model='form.fechaVacaciones' locale="es" :min='dateVacaciones' :readonly='read')
                        v-spacer
                        v-btn(small dark color='red' @click='modalVacaciones = false') Cancelar
                        v-btn(small dark color='success' @click='$refs.dialog2.save(dateVacaciones)') Ok

                //v-row(dense)
                  v-col(cols='4' v-if="editedIndex === -1")
                    v-autocomplete(v-model='selecEstado' :readonly='read'  label='Estado' :items='idEstadoArray' @change='changeEstado' id='estadoEmpleado' outlined dense)
                  v-col(cols='4' v-else)
                    v-autocomplete(v-model='form.codEstado._id' :readonly='read'  label='Estado' :items='idEstadoArray' @change='changeEstado' outlined dense)
                  v-col(cols='4' v-if="editedIndex === -1")
                    v-autocomplete(v-model='selecMunicipio' :readonly='read'  label='Municipio' :items='arrayMunicipioEstado' @change='changeMunicipio' id='municipioEmpleado' outlined dense)
                  v-col(cols='4' v-else)
                    v-autocomplete(v-model='form.codMunicipio._id' :readonly='read'  label='Municipio' :items='arrayMunicipioEstado' @change='changeMunicipio' outlined dense)
                  v-col(cols='4' v-if="editedIndex === -1")
                    v-autocomplete(v-model='form.codParroquia' :readonly='read'  label='Parroquia' :items='arrayParroquiaMunicipio' id='parroquiaEmpleado' outlined dense)
                  v-col(cols='4' v-else)
                    v-autocomplete(v-model='form.codParroquia._id' :readonly='read'  label='Parroquia' :items='arrayParroquiaMunicipio' outlined dense)
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
import ListadoVendedores from '@/components/ListadoVendedores'
import ListadoPromotores from '@/components/tipoEmpleados/ListadoPromotores'
import ListadoClientes from '@/components/tipoEmpleados/ListadoClientes'
import TipoEmpleadoM from '@/components/modals/TipoEmpleadoM'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read', 'tipoEmpleado'],
  name: 'EmpleadoM',
  data: () => ({
    tipoEmp: false,
    config: null,
    // selecEstado: "",
    // selecMunicipio: "",
    // selecParroquia: "",
    selecEmp: '',
    selecZ: '',
    selecR: '',

    dialog1: false,
    dialog2: false,
    mostrar: false,
    mostrarPoRu: false,

    mostrarPromotores: false,
    mostrarClientes: false,

    // dateIngreso: new Date().toISOString().substr(0, 10),
    // dateVacaciones: new Date().toISOString().substr(0, 10),
    // modalIngreso: false,
    // modalVacaciones: false,
    // estado: [],
    // idEstadoArray: [],
    // municipio: [],
    // idMunicipioArray: [],
    // parroquia: [],
    // idParroquiaArray: [],
    // arrayMunicipioEstado: [],
    // arrayParroquiaMunicipio: [],

    portafolio: [],
    idPortafolioArray: [],
    zona: [],
    ruta: [],
    idZonaArray: [],
    idRutaArray: [],

    idArrayRutaZona: [],

    tipo: [],
    tipoArray: [],

    rifNumerico: '',
    rifLetra: 'V',
    empleados: [],

    form: {
      cedula: '',
      rif: '',
      nombre: '',
      apellido: '',
      // fechaIngreso: "",
      // fechaVacaciones: "",
      // codEstado: "",
      // codMunicipio: "",
      // codParroquia: "",
      direccion: '',
      telefono: '',
      tipoEmpleado: '',
      vendedor: [],
      promotores: [],
      clientes: [],
      codZona: null,
      codRuta: null,
      codPortafolio: null
    },
    items2: ['V', 'E'],
    defaultForm: {
      cedula: '',
      rif: '',
      nombre: '',
      apellido: '',
      // fechaIngreso: "",
      // fechaVacaciones: "",
      // codEstado: "",
      // codMunicipio: "",
      // codParroquia: "",
      direccion: '',
      telefono: '',
      tipoEmpleado: '',
      vendedor: [],
      promotores: [],
      clientes: [],
      codZona: null,
      codRuta: null,
      codPortafolio: null
    },
    activator: null
  }),
  components: {
    ListadoVendedores,
    TipoEmpleadoM,
    ListadoPromotores,
    ListadoClientes
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (val.tipoEmpleado.descripcion.toLowerCase() === 'supervisor') {
        this.mostrarPoRu = false
        this.mostrar = true
        this.mostrarPromotores = false
        this.mostrarClientes = false
      } else if (val.tipoEmpleado.descripcion.toLowerCase() === 'vendedor') {
        this.mostrar = false
        this.mostrarPoRu = true
        this.mostrarPromotores = false
        this.mostrarClientes = false
      } else if (val.tipoEmpleado.descripcion.toLowerCase() === 'promotor') {
        this.mostrarPromotores = false
        this.mostrar = false
        this.mostrarPoRu = false
        this.mostrarClientes = true
        // habilitar tabla de clientes
      } else if (val.tipoEmpleado.descripcion.toLowerCase() === 'supervisor de promotores') {
        this.mostrarClientes = false
        this.mostrarPromotores = true
        this.mostrar = false
        this.mostrarPoRu = false
        // habilitar tabla de promotores
      } else {
        this.mostrar = false
        this.mostrarPoRu = false
        this.mostrarClientes = false
        this.mostrarPromotores = false
      }
      if (Object.keys(val).length !== 0) {
        this.form = val
        // this.selecParroquia = this.val.codParroquia._id;
        // this.selecEstado = this.val.codEstado._id;
        // this.selecMunicipio = this.val.codMunicipio._id;
        // this.changeEstado(val.codEstado);
        // this.changeMunicipio(val.codMunicipio);
        // this.changeParroquia(val.codParroquia);
        // this.tipoSeleccionado(val.tipoEmpleado._id)
        // if (val.codZona) this.zonaSeleccionada(val.codZona._id)
        this.desconcatenarRif(val.rif)
        if (val.tipoEmpleado?._id) this.selecEmp = val.tipoEmpleado._id
      }
    },
    tipoEmpleado (val) {
      const empleado = this.tipo.find(empleado => empleado.descripcion === val)
      this.selecEmp = empleado._id
      this.form.tipoEmpleado = empleado
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Empleado'
        : this.read
          ? 'Informacion del Empleado'
          : 'Modificar Empleado'
    }
  },
  created () {
    this.initialize()
    this.getTipoEmpleado()
    /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                         permiso => permiso.ruta == "Empleado"
     ); */
  },
  methods: {
    getTipoEmpleado () {
      Api.get('/tipoEmpleado')
        .then(response => {
          this.tipo = response.data
          this.tipo.map(data => {
            this.tipoArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    zonaSeleccionada (data) {
      const z = this.zona.find(z => z._id === data)
      if (z) {
        this.form.codZona = z
        this.selecZ = this.form.codZona._id
        this.idRutaArray = []
        for (let i = 0; i < this.idArrayRutaZona.length; i++) {
          if (data === this.idArrayRutaZona[i].codZona._id) {
            this.idRutaArray.push(this.idArrayRutaZona[i])
          }
        }
      }
    },

    rutaSeleccionada (data) {
      const r = this.ruta.find(r => r._id === data)
      this.form.codRuta = r
    },

    tipoSeleccionado (data) {
      const empleado = this.tipo.find(empleado => empleado._id === data)
      this.form.tipoEmpleado = empleado
      if (this.form.tipoEmpleado.descripcion === 'Supervisor' || this.form.tipoEmpleado.descripcion === 'SUPERVISOR' || this.form.tipoEmpleado.descripcion === 'supervisor') {
        this.mostrarPoRu = false
        this.mostrar = true
        this.mostrarPromotores = false
        this.mostrarClientes = false
      } else if (this.form.tipoEmpleado.descripcion === 'Vendedor' || this.form.tipoEmpleado.descripcion === 'VENDEDOR' || this.form.tipoEmpleado.descripcion === 'vendedor') {
        this.mostrar = false
        this.mostrarPoRu = true
        this.mostrarPromotores = false
        this.mostrarClientes = false
      } else if (this.form.tipoEmpleado.descripcion.toLowerCase() === 'promotor') {
        console.log('es un promotor')
        this.mostrarPromotores = false
        this.mostrar = false
        this.mostrarPoRu = false
        this.mostrarClientes = true
        // habilitar tabla de clientes
      } else if (this.form.tipoEmpleado.descripcion.toLowerCase() === 'supervisor de promotores') {
        console.log('es un supervisor')
        this.mostrarClientes = false
        this.mostrarPromotores = true
        this.mostrar = false
        this.mostrarPoRu = false
        // habilitar tabla de promotores
      } else {
        this.mostrar = false
        this.mostrarPoRu = false
        this.mostrarClientes = false
        this.mostrarPromotores = false
      }
    },
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD')
    },
    // changeEstado(data) {
    //   const es = this.estado.find(es => es._id == data);
    //   this.form.codEstado = es;
    //   this.selecEstado = this.form.codEstado._id;
    //   this.arrayMunicipioEstado = [];
    //   for (let i = 0; i < this.idMunicipioArray.length; i++) {
    //     if (data == this.idMunicipioArray[i].codEstado) {
    //       this.arrayMunicipioEstado.push(this.idMunicipioArray[i]);
    //     }
    //   }
    // },
    // changeMunicipio(data) {
    //   const mu = this.municipio.find(mu => mu._id == data);
    //   this.form.codMunicipio = mu;
    //   this.selecMunicipio = this.form.codMunicipio._id;
    //   this.arrayParroquiaMunicipio = [];
    //   for (let i = 0; i < this.idParroquiaArray.length; i++) {
    //     if (data == this.idParroquiaArray[i].codMunicipio) {
    //       this.arrayParroquiaMunicipio.push(this.idParroquiaArray[i]);
    //     }
    //   }
    // },
    // changeParroquia(data) {
    //   const pa = this.parroquia.find(pa => pa._id == data);
    //   this.form.codParroquia = pa;
    // },
    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },
    desconcatenarRif (rif) {
      this.rifLetra = rif.charAt(0)
      this.rifNumerico = rif.substr(2)
    },
    initialize () {
      this.config = this.$store.state.config.empleados
      // this.listarEstados();
      // this.listarMunicipio();
      // this.listarParroquia();
      this.listarPortafolios()
      this.listarZonas()
      this.listarRutas()
      /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                          permiso => permiso.ruta == "Empleado") */
    },
    listarPortafolios () {
      Api.get('/portafolio')
        .then(response => {
          this.portafolio = response.data
          this.portafolio.map(data => {
            this.idPortafolioArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarZonas () {
      Api.get('/zona')
        .then(response => {
          this.zona = response.data
          this.zona.map(data => {
            this.idZonaArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarRutas () {
      Api.get('/ruta')
        .then(response => {
          this.ruta = response.data
          this.ruta.map(data => {
            this.idArrayRutaZona.push({
              text: data.descripcion,
              value: data._id,
              codZona: data.codZona
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarEmpleados () {
      Api.get('/empleado')
        .then(response => {
          this.empleados = response.data
          this.empleados.map(data => {
            data.fechaIngreso = this.formato(data.fechaIngreso)
            data.fechaVacaciones = this.formato(data.fechaVacaciones)
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    // listarEstados() {
    //   Api.get("/estado")
    //     .then(response => {
    //       this.estado = response.data;
    //       this.estado.map(data => {
    //         this.idEstadoArray.push({
    //           text: data.nombre,
    //           value: data._id
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarMunicipio() {
    //   Api.get("/municipio")
    //     .then(response => {
    //       this.municipio = response.data;
    //       this.municipio.map(data => {
    //         this.idMunicipioArray.push({
    //           text: data.nombre,
    //           value: data._id,
    //           codEstado: data.codEstado
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    // listarParroquia() {
    //   Api.get("/parroquia")
    //     .then(response => {
    //       this.parroquia = response.data;
    //       this.parroquia.map(data => {
    //         this.idParroquiaArray.push({
    //           text: data.nombre,
    //           value: data._id,
    //           codMunicipio: data.codMunicipio
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },
    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
        this.selecEstado = ''
        this.selecMunicipio = ''
        this.selecEmp = ''
        this.ListadoVendedores = ''
        this.rifNumerico = ''
        this.rifLetra = ''
        this.form.rif = ''
        this.selecZ = ''
        this.selecR = ''
        this.mostrarPoRu = false
        this.mostrar = false
      }, 300)
      // pone el dialog del padre en false
      this.$emit('close')
    },
    validarCampos () {
      if (
        this.form.cedula === '' ||
        this.rifLetra === '' ||
        this.rifNumerico === '' ||
        this.form.nombre === '' ||
        this.form.apellido === '' ||
        this.form.direccion === '' ||
        this.form.telefono === '' ||
        // this.form.fechaIngreso === "" ||
        // this.form.fechaVacaciones === "" ||
        // this.form.codEstado === "" ||
        // this.form.codMunicipio === "" ||
        // this.form.codParroquia === "" ||
        this.form.tipoEmpleado === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      } else if (this.form.cedula.length < 7) {
        this.$swal({
          icon: 'error',
          title: 'Cedula invalida',
          text: 'Por favor ingrese una cedula correcta'
        })
        return true
      } else if (
        this.form.nombre.length > 20 ||
        this.form.apellido.length > 40
      ) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Ha excedido el limite de caracteres'
        })
        return true
      } else if (this.form.telefono.length !== 15) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text:
            'El campo de telefono debe tener 15 digitos, por favor verifique'
        })
        return true
      } else if (
        this.form.tipoEmpleado.descripcion === 'Supervisor' &&
        this.form.vendedor.length <= 0
      ) {
        this.$swal({
          icon: 'error',
          title: 'No existen vendedores cargados',
          text: 'Carge vendedores para continuar'
        })
        return true
      // } else if (this.form.fechaIngreso >= this.form.fechaVacaciones) {
      //   this.$swal({
      //     icon: "error",
      //     title: "Error en las fechas",
      //     text:
      //       "Fecha de ingreso no puede ser mayor o igual a Fecha de Vacaciones"
      //   });
      //   return true;
      } else if (this.rifNumerico.length < 7) {
        this.$swal({
          icon: 'error',
          title: 'Rif invalido',
          text: 'El rif debe tener entre 7 a 9 caracteres'
        })
        return true
      } else if (this.rifNumerico.slice(0, -1) !== this.form.cedula) {
        this.$swal({
          icon: 'error',
          title: 'El rif y la cedula deben coincidir',
          text: 'Por favor, verifique'
        })
        return true
      }
      return false
    },
    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.concatenarRif()
        if (this.editedIndex > -1) {
          Api.put('/empleado', this.form)
            .then(response => {
              this.$emit('edited', this.form)
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        } else {
          Api.post('/empleado', this.form)
            .then(response => {
              // llama al metodo de padre, para listar de nuevo
              this.$emit('save', this.form)
              // this.form._id = response.data._id;
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.empleados.push(response.data)
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message)
              }
            })
        }
      }
    }
  }
}
</script>
